import React, { useEffect, useState } from 'react';
import OrderDetailSection from './OrderDetailSection';
import { ButtonComp } from 'atoms/Buttons';
import isArray from 'lodash/isArray';
import { useSelector, useDispatch } from 'react-redux';
import ReOrderComponent from './ReOrderComponent';
import OrderItemDetailsComponent from './OrderItemDetailsComponent';
import { getOrderHistory } from '@kfc-global/react-shared/redux/Actions/OrderHistoryAction';
import OrderLookup from '../../FooterComponent/Presentation/orderLookUp';
import { useHistory } from 'react-router-dom';
import { getOrdersAction, clearPastOrderAction } from '@kfc-global/react-shared/redux/Actions/orderAction';
import { isEmptyObject, isMobileDevice } from '../../../common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ORDER_HISTORY from '../Constants/Constants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const OrderHistorySection = ({ renderSwitch, updateMenu }) => {
  const history = useHistory();
  const {
    NO_ORDER_MSG,
    REFUND_MSG,
    HAVE_A_QUESTION,
    CONNECT_WITH_SPECIALIST,
    YOUR_PAST_ORDER,
    LOOKING_FOR_OFFER,
    ORDER_HISTORY_TAG,
    REFUND_INIT,
    GET_HELP,
    LOAD_MORE,
    VIEWED,
    OF,
    ORDER_LOOKUP,
    VIEW_MENU,
  } = ORDER_HISTORY;
  const { Arrow } = IMAGE_PATH;
  const { tenantData, orderHistoryInfo, orderInfo, customerInfo } = useSelector(data => {
    return {
      tenantData: data.tenantReducer || {},
      orderHistoryInfo: data.orderHistoryReducer || {},
      orderInfo: data.orderReducer || {},
      customerInfo: data.profileReducer || {},
    };
  });

  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  useEffect(() => {
    return () => {
      localStorage.removeItem('LoadMoreOrderHistory');
    };
  }, []);
  useEffect(() => {
    window.addEventListener('resize', () => {
      const isMobileView = isMobileDevice(window.innerWidth);
      setMobileHeader(isMobileView);
    });
  }, [isMobile]);

  const dispatch = useDispatch();

  const { tenantId } = tenantData;
  const { orderHistory } = orderHistoryInfo;
  const { favouriteItems, customerId, favouriteOrders = [] } = customerInfo;
  const { response: orderDetails, isGetOrdersLoading } = orderInfo;
  const [orders, setOrders] = useState([]);
  const [orderItemArray, setOrderItemArray] = useState([]);
  const [openModal, setOpen] = useState(false);
  const getPastMonthYear = number => {
    const monthNames = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    const monthYear = [];
    const today = new Date();
    const todaysMonth = today.getMonth() + 1;
    let d;
    let month;

    for (let i = number; i > 0; i -= 1) {
      d = new Date(today.getFullYear(), todaysMonth - i, 1);
      month = monthNames[d.getMonth()];
      let year = today.getFullYear();
      if (month > todaysMonth) {
        year = year - 1;
      }
      monthYear.push({ yearMonth: `${year}-${month}` });
    }
    return monthYear;
  };

  const getOrderHistoryInfo = () => {
    const postBody = getPastMonthYear(12);
    dispatch(
      getOrderHistory(
        {
          customerId,
          tenantId,
        },
        postBody,
      ),
    );
  };

  useEffect(() => {
    if (tenantId) {
      getOrderHistoryInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId, customerId]);

  useEffect(() => {
    const orderItem = orderItemArray.find(order => order.id === orderDetails.id) || {};
    if (!isEmptyObject(orderItem)) {
      setOrderItemArray([...orderItemArray, orderDetails]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails]);

  useEffect(() => {
    loadOrderHistory(10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderHistory]);

  const loadOrderHistory = spliceFrom => {
    if (orderHistory && isArray(orderHistory)) {
      const orderData = orderHistory?.sort((itemA, itemB) => itemB.orderDateTimeInEpoch - itemA.orderDateTimeInEpoch);

      setOrders([...orderData].splice(0, spliceFrom));
    } else {
      setOrders([]);
    }
  };

  const onClickHandler = (e, orderId) => {
    const orderItem = orderItemArray.find(order => order.id === orderId) || {};

    if (!isEmptyObject(orderItem)) {
      dispatch(
        getOrdersAction({
          orderId: orderId,
          tenantId,
        }),
      );
    }

    const accordian = e.target.parentElement.parentElement.parentElement;
    accordian.classList.contains('account-accordian-open')
      ? accordian.classList.remove('account-accordian-open')
      : accordian.classList.add('account-accordian-open');
  };

  const getHelp = () => {
    history.push('/help');
  };

  const goToMenuPage = () => {
    history.push('/menu');
  };
  const onOpenLookup = () => {
    dispatch(clearPastOrderAction({}));
    setOpen(true);
  };
  const refundOrderDetails = (
    <div className='global-accordian-header-container mobile-refund-section'>
      <span className='global-accordian-header'>
        <span className='order-refund-msg'>{translateWithI18Next(REFUND_MSG)}</span>
      </span>
      <div className='global-accordian-right'>
        {
          <ButtonComp
            className='button transparent-btn'
            aria-label={''}
            data-testid='get-Help-Btn'
            type='submit'
            onClickHandler={getHelp}
          >
            <span>{translateWithI18Next(GET_HELP)}</span>
          </ButtonComp>
        }
      </div>
    </div>
  );

  const pageFooter = (
    <div className='pageFooter'>
      {orders.length > 0 && orderHistory.length > orders.length && orderHistory.length > 10 && (
        <div>
          <div className='load-more'>
            <ButtonComp
              className='button transparent-btn footer-btn'
              data-testid='load-more-btn'
              aria-label={''}
              onClickHandler={() => loadOrderHistory(orderHistory.length)}
            >
              <span>{translateWithI18Next(LOAD_MORE)}</span>
            </ButtonComp>
          </div>
          <div className='view-order-count'>
            <span>{`${translateWithI18Next(VIEWED)} ${orders.length} ${translateWithI18Next(OF)} ${
              orderHistory.length
            }`}</span>
          </div>
        </div>
      )}
      <hr className='horizontal-bar' />
      <div className='get-help-section'>
        <div className='footer-bootm-left'>
          <span className='have-a-question'>{translateWithI18Next(HAVE_A_QUESTION)}</span>
          <span className='connect-specialist'>{translateWithI18Next(CONNECT_WITH_SPECIALIST)}</span>
        </div>
        <div>
          <ButtonComp className='button transparent-btn footer-btn' aria-label={''} onClickHandler={getHelp}>
            <span>{translateWithI18Next(GET_HELP)}</span>
          </ButtonComp>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {isMobile && (
        <div className='order-history-header'>
          <img
            src={Arrow}
            className='back-icon'
            alt='Back Icon'
            data-testid='order-history-back-btn'
            data
            onClick={() => {
              renderSwitch();
              updateMenu('');
            }}
          />
          <span className='page-heading'>{translateWithI18Next(ORDER_HISTORY_TAG)}</span>
        </div>
      )}
      <div className='account-order-desktop'>
        <div className='page-header'>
          <span className='page-heading'>{translateWithI18Next(ORDER_HISTORY_TAG)}</span>
          <div className='headingItemsRight'>
            <span className='heading-item-text'>{translateWithI18Next(LOOKING_FOR_OFFER)}</span>
            <ButtonComp
              className='button transparent-btn order-lookup'
              data-testid='order-lookup-order-history'
              type='submit'
              onClickHandler={onOpenLookup}
            >
              <span>{translateWithI18Next(ORDER_LOOKUP)}</span>
            </ButtonComp>
          </div>
        </div>
        {orders.length > 0 && (
          <div className='sub-section'>
            <span className='sub-heading-text'>
              {translateWithI18Next(YOUR_PAST_ORDER)} ({orderHistory.length})
            </span>
            <section>
              {orders.map((info, index) => (
                <section className={`account-accordian`}>
                  <OrderDetailSection
                    onClickHandler={onClickHandler}
                    cardInfo={info}
                    dataTestId={`order-details-${index}`}
                    favouriteOrders={favouriteOrders}
                    tenantData={tenantData}
                  >
                    {info.status === REFUND_INIT && refundOrderDetails}
                    <section className={`account-accordian-details-section`}>
                      <div className='option-section'>
                        <OrderItemDetailsComponent
                          key={index}
                          cardInfo={info}
                          tenantData={tenantData}
                          orderItemArray={orderItemArray}
                          favouriteItems={favouriteItems}
                          customerId={customerId}
                        />
                      </div>
                      <ReOrderComponent
                        isMobile={isMobile}
                        orderItemArray={orderItemArray}
                        cardInfo={info}
                        tenantData={tenantData}
                        customerId={customerId}
                        key={`Reorder-${index}`}
                        isGetOrdersLoading={isGetOrdersLoading}
                      />
                    </section>
                  </OrderDetailSection>
                </section>
              ))}
            </section>
          </div>
        )}
        {orders.length === 0 && (
          <div className='sub-section sub-section-no-order'>
            <div className='no-order'>
              <span className='no-order-msg'>{translateWithI18Next(NO_ORDER_MSG)}</span>
              <div>
                <ButtonComp
                  className='button transparent-btn view-menu-btn'
                  aria-label={''}
                  data-testid='goto-menu-page-btn'
                  onClickHandler={goToMenuPage}
                >
                  <span>{translateWithI18Next(VIEW_MENU)}</span>
                </ButtonComp>
              </div>
            </div>
          </div>
        )}
        {pageFooter}
        {openModal && <OrderLookup isOpen={true} handleClose={() => setOpen(false)} tenantReducerData={tenantData} />}
      </div>
    </>
  );
};

export default OrderHistorySection;
